import React, { useState, useEffect } from 'react';
import { ShoppingBag, Compass } from 'lucide-react';
import '../ecommerce.css';
import layout2 from '../images/layout-2.jpg';
import layout3 from '../images/layout-3.jpg';
import layout1 from '../images/layout-1.jpg';
import CategoryCard from '../components/CategoryCard';
import '../ecommerce.css'
import { Link } from 'react-router-dom';

const Header = () => {
  const images = [
    layout1,
    layout2,
    layout3,
  ];
  const categories = [
    {
      name: 'Chairs',
      description: 'Comfort meets style',
      image: 'https://images.unsplash.com/photo-1592078615290-033ee584e267?auto=format&fit=crop&q=80',
    },
    {
      name: 'Tables',
      description: 'Gather & connect',
      image: 'https://images.unsplash.com/photo-1533090481720-856c6e3c1fdc?auto=format&fit=crop&q=80',
    },
    {
      name: 'Sofas',
      description: 'Luxurious lounging',
      image: 'https://images.unsplash.com/photo-1540574163026-643ea20ade25?auto=format&fit=crop&q=80',
    },
    {
      name: 'Storage',
      description: 'Organize in style',
      image: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); 

    return () => clearInterval(interval); 
  }, [images.length]);

  const handleLandingImg = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className='overflow-hidden'>
      <div
      className='w-screen h-screen flex justify-center items-center text-white text-center relative '
      id='layout'
      style={{
        backgroundImage: `url(${images[currentIndex]})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        transition: 'background-image 0.8s ease-in-out',
      }}
    >
      <div className="absolute inset-0 bg-black/40" />
      <div className='absolute z-10 w-[50%] max-md:w-[98%]'>
        <h1 className='text-[55px] font-bold capitalize mb-6 leading-[52px] tracking-tight'>
          Create your perfect nest with Nestora
        </h1>
        <p className='text-2xl mb-5'>
          Discover curated collections of timeless furniture and decor that transform your space into a sanctuary of style and comfort.
        </p>
        <div className='flex justify-center items-center'>
        <Link to='/register'>
          <button className='bg-violet-600 pt-3 pb-3 pl-5 pr-5 text-[18px] rounded-3xl mr-4 hover:bg-violet-800 flex items-center gap-2'>
            <ShoppingBag /> Shop Now
          </button>
          </Link>
          <button className='text-violet-600 bg-white pt-3 pb-3 pl-5 pr-5 text-[17px] rounded-3xl hover:text-violet-800 flex items-center gap-2'>
            <Compass /> Explore collections
          </button>
        </div>
      </div>

      
      <div className='absolute z-10 bottom-7 flex gap-5'>
        {images.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 rounded-full cursor-pointer ${
              currentIndex === index ? 'bg-white' : 'bg-white opacity-60'
            }`}
            onClick={() => handleLandingImg(index)}
          ></div>
        ))}
      </div>
    </div>
    <div className='mt-8'>
      <div className='text-center '>
        <h1 className='font-semibold  text-4xl mb-3'>Featured Categories</h1>
        <p className='text-gray-700'>Explore our carefully curated collection of furniture pieces designed to elevate your living space</p>
      </div>
      <div className='flex justify-center items-center flex-wrap'>
        {categories.map((item , index)=><CategoryCard item={item} key ={index}/>)}
      </div>
    </div>
    </div>
  );
};

export default Header;
